import React from "react"

export const PlayButton = () => (
  <svg
    width="53"
    height="53"
    viewBox="0 0 53 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="26.5" cy="26.5" r="26.5" fill="white" />
    <path
      d="M23.1453 36.141L35.9332 28.0668C37.0739 27.3486 37.0776 25.5785 35.9332 24.8604L23.1453 16.7823C22.1062 16.1263 20.515 16.7629 20.515 18.3855V34.5378C20.515 35.9935 21.9936 36.8707 23.1453 36.141Z"
      fill="#0022B7"
    />
  </svg>
)

export const PaginationArrow = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" id="blue" height="48" rx="24" fill="#002DC2" />
    <path
      d="M22 32L30 24L22 16"
      stroke="white"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export const SearchIcon = ({ props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 19L14.65 14.65M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z"
      stroke="#7A8A9D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export const ClearIcon = ({ props }) => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.75 6.75L6.25 11.25M6.25 6.75L10.75 11.25M16 9C16 13.1421 12.6421 16.5 8.5 16.5C4.35786 16.5 1 13.1421 1 9C1 4.85786 4.35786 1.5 8.5 1.5C12.6421 1.5 16 4.85786 16 9Z"
      stroke="#002DC2"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export const Arrow = () => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.25 6H11.75M11.75 6L6.5 0.75M11.75 6L6.5 11.25"
      stroke="#002DC2"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export const CloseButton = ({ props }) => (
  <svg
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m1 1 8 8m0 0 8 8m-8-8 8-8m-8 8-8 8"
      stroke="#fff"
      stroke-linecap="round"
      stroke-width="2"
    />
  </svg>
)

export const ITIcon = () => (
  <svg
    width="40"
    height="42"
    viewBox="0 0 40 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8053 1L8.08447 4.72086V37.2784H35.9909V1H11.8053Z"
      stroke="#002DC2"
      stroke-width="1.75"
      stroke-linecap="round"
    />
    <path
      d="M4.36377 8.44238V40.9999H32.2702"
      stroke="#002DC2"
      stroke-width="1.75"
      stroke-miterlimit="10"
    />
    <path
      d="M20.6982 25.5464H28.5892"
      stroke="#002DC2"
      stroke-width="1.25"
      stroke-miterlimit="10"
    />
    <path
      d="M20.6982 29.0244H25.9589"
      stroke="#002DC2"
      stroke-width="1.25"
      stroke-miterlimit="10"
    />
    <path
      d="M18.0683 24.6768L14.5612 29.0246L12.8076 26.4159"
      stroke="#002DC2"
      stroke-width="1.25"
      stroke-miterlimit="10"
    />
    <circle
      cx="22.252"
      cy="13.252"
      r="6.62695"
      stroke="#002DC2"
      stroke-width="1.25"
    />
    <path
      d="M22.252 9.62598V13.252H25.8779"
      stroke="#002DC2"
      stroke-width="1.25"
      stroke-linecap="square"
    />
  </svg>
)

export const ProductivityIcon = () => (
  <svg
    width="43"
    height="41"
    viewBox="0 0 43 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2117 29.6836C10.1562 29.6836 8.7334 28.0832 8.7334 26.1095V24.9178C8.7334 22.9442 10.1562 21.3438 12.2117 21.3438C14.2671 21.3438 15.6899 22.9442 15.6899 24.9178V26.1095C15.6899 28.0832 14.2671 29.6836 12.2117 29.6836Z"
      stroke="#002DC2"
      stroke-width="1.75"
      stroke-miterlimit="10"
    />
    <path
      d="M4.38574 39.6927L6.12487 33.0199C6.64987 30.9347 7.69009 29.6836 9.60313 29.6836H10.552C11.0542 29.6836 11.5325 29.8921 11.8629 30.2549L17.414 36.3563H22.6314C22.6314 36.3563 23.0205 39.6927 20.0227 39.6927H14.8216L10.4738 35.5222"
      stroke="#002DC2"
      stroke-width="1.75"
      stroke-miterlimit="10"
    />
    <path
      d="M18.2983 33.8542L21.7766 28.0156H37.4288L32.2114 37.1906H24.3853"
      stroke="#002DC2"
      stroke-width="1.75"
      stroke-miterlimit="10"
    />
    <path
      d="M11.3418 39.6924H37.4288"
      stroke="#002DC2"
      stroke-width="1.75"
      stroke-miterlimit="10"
    />
    <path
      d="M3.40729 33.02H1.77686V5.49512H41.7769V33.02H38.1355"
      stroke="#002DC2"
      stroke-width="1.75"
      stroke-miterlimit="10"
    />
    <path
      d="M23 10.7979L18 16.7979H22.5L22 20.7979L27 14.7979H22.5L23 10.7979Z"
      stroke="#002DC2"
      stroke-width="1.25"
      stroke-linecap="round"
    />
  </svg>
)

export const ApprovalsIcon = () => (
  <svg
    width="40"
    height="43"
    viewBox="0 0 40 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.5639 29.5027V39.9375C35.5639 40.894 34.7748 41.6766 33.8103 41.6766H5.75355C4.7891 41.6766 4 40.894 4 39.9375V7.76354C4 6.80702 4.7891 6.02441 5.75355 6.02441H9.26065"
      stroke="#002DC2"
      stroke-width="1.75"
      stroke-miterlimit="10"
    />
    <path
      d="M30.3032 6.02441H33.8103C34.7748 6.02441 35.5639 6.80702 35.5639 7.76354V29.6363"
      stroke="#002DC2"
      stroke-width="1.75"
      stroke-miterlimit="10"
    />
    <path
      d="M32.057 32.9812V38.1986H7.50732V9.50293H9.26087"
      stroke="#002DC2"
      stroke-width="1.75"
      stroke-miterlimit="10"
    />
    <path
      d="M30.3032 9.50293H32.0568V33.2728"
      stroke="#002DC2"
      stroke-width="1.75"
      stroke-miterlimit="10"
    />
    <path
      d="M25.9193 5.15502H23.289C23.289 3.23328 21.7196 1.67676 19.7819 1.67676C17.8442 1.67676 16.2748 3.23328 16.2748 5.15502H13.6445C12.189 5.15502 11.0142 6.32024 11.0142 7.76371V10.3724H28.5497V7.76371C28.5497 6.32024 27.3748 5.15502 25.9193 5.15502Z"
      stroke="#002DC2"
      stroke-width="1.75"
      stroke-miterlimit="10"
    />
    <path
      d="M19.7817 4.28564V6.02478"
      stroke="#002DC2"
      stroke-width="1.75"
      stroke-miterlimit="10"
    />
    <path
      d="M19.7817 14.7202H27.6727"
      stroke="#002DC2"
      stroke-width="1.25"
      stroke-miterlimit="10"
    />
    <path
      d="M17.1518 13.8506L13.6447 18.1984L11.8911 15.5897"
      stroke="#002DC2"
      stroke-width="1.25"
      stroke-miterlimit="10"
    />
    <path
      d="M19.7817 22.5464H27.6727"
      stroke="#002DC2"
      stroke-width="1.25"
      stroke-miterlimit="10"
    />
    <path
      d="M19.7817 30.5464H27.6727"
      stroke="#002DC2"
      stroke-width="1.25"
      stroke-miterlimit="10"
    />
    <path
      d="M19.7817 18.1987H25.9192"
      stroke="#002DC2"
      stroke-width="1.25"
      stroke-miterlimit="10"
    />
    <path
      d="M19.7817 26.0244H25.0424"
      stroke="#002DC2"
      stroke-width="1.25"
      stroke-miterlimit="10"
    />
    <path
      d="M19.7817 34.0249H25.0424"
      stroke="#002DC2"
      stroke-width="1.25"
      stroke-miterlimit="10"
    />
    <path
      d="M17.1518 21.6768L13.6447 26.0246L11.8911 23.4159"
      stroke="#002DC2"
      stroke-width="1.25"
      stroke-miterlimit="10"
    />
    <path
      d="M17.1518 29.5029L13.6447 33.8508L11.8911 31.2421"
      stroke="#002DC2"
      stroke-width="1.25"
      stroke-miterlimit="10"
    />
  </svg>
)

export const HeadIcon = () => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 9.5H6C2.9375 9.5 0.5 11.9688 0.5 15C0.5 15.5625 0.9375 16 1.5 16H13.5C14.0313 16 14.5 15.5625 14.5 15C14.5 11.9688 12.0313 9.5 9 9.5ZM2 14.5C2.25 12.5313 3.9375 11 6 11H9C11.0312 11 12.7188 12.5313 12.9688 14.5H2ZM7.5 8C9.6875 8 11.5 6.21875 11.5 4C11.5 1.8125 9.6875 0 7.5 0C5.28125 0 3.5 1.8125 3.5 4C3.5 6.21875 5.28125 8 7.5 8ZM7.5 1.5C8.875 1.5 10 2.625 10 4C10 5.40625 8.875 6.5 7.5 6.5C6.09375 6.5 5 5.40625 5 4C5 2.625 6.09375 1.5 7.5 1.5Z"
      fill="white"
    />
  </svg>
)

export const Calendar = () => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 2H11.25V0.75C11.25 0.34375 10.9062 0 10.5 0C10.0625 0 9.75 0.34375 9.75 0.75V2H5.25V0.75C5.25 0.34375 4.90625 0 4.5 0C4.0625 0 3.75 0.34375 3.75 0.75V2H2.5C1.375 2 0.5 2.90625 0.5 4V14C0.5 15.125 1.375 16 2.5 16H12.5C13.5938 16 14.5 15.125 14.5 14V4C14.5 2.90625 13.5938 2 12.5 2ZM12.5 14.5H2.5C2.21875 14.5 2 14.2813 2 14V6H13V14C13 14.2813 12.75 14.5 12.5 14.5Z"
      fill="white"
    />
  </svg>
)

export const Spotify = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.5 40C31.5457 40 40.5 31.0457 40.5 20C40.5 8.9543 31.5457 0 20.5 0C9.4543 0 0.5 8.9543 0.5 20C0.5 31.0457 9.4543 40 20.5 40ZM27.9518 28.4015C28.5212 28.7268 29.2502 28.575 29.5919 28.0328C29.9336 27.4906 29.7513 26.7966 29.1819 26.4713C24.1704 23.5436 17.9288 22.8713 10.6621 24.4545C10.0243 24.5846 9.637 25.1918 9.77368 25.799C9.91036 26.4063 10.5482 26.775 11.186 26.6448C17.8376 25.2135 23.4642 25.799 27.9518 28.4015ZM29.8652 23.5653C30.5714 23.9557 31.4826 23.7605 31.9154 23.0882C32.3482 22.4159 32.1204 21.5484 31.4598 21.158C25.5599 17.7098 16.9492 16.7556 10.0243 18.7508C9.22697 18.9677 8.79416 19.7484 9.02196 20.5074C9.24975 21.2448 10.0698 21.6568 10.8671 21.44C16.9265 19.6833 24.7398 20.5508 29.8652 23.5653ZM9.95592 15.8231C15.833 14.1315 25.9699 14.4568 32.1204 17.9267C32.9633 18.4255 34.0567 18.1436 34.535 17.3195C35.0362 16.517 34.7628 15.4761 33.92 14.999C26.8583 11.0086 15.6508 10.6182 8.90806 12.57C7.9741 12.852 7.42739 13.8062 7.72352 14.6953C8.01966 15.6062 9.02196 16.105 9.95592 15.8231Z"
      fill="white"
    />
  </svg>
)

export const ApplePodcast = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.3046 8.3443C25.7497 8.13488 30.333 12.3779 30.5424 17.8229C30.5468 17.9451 30.549 18.0672 30.549 18.1916C30.5511 20.9141 29.4233 23.5144 27.4338 25.3731C27.2723 25.5258 27.1851 25.7417 27.196 25.9643C27.2331 26.6405 27.22 27.2993 27.1764 28.041C27.1676 28.1741 27.2702 28.2875 27.4011 28.2941C27.4534 28.2985 27.5058 28.2832 27.5494 28.2548C30.8805 25.9861 32.8744 22.2186 32.8744 18.1894C32.8679 11.4551 27.4032 6.00137 20.669 6.00792C20.5163 6.00792 20.3635 6.0101 20.2108 6.01664C13.7645 6.26533 8.59219 11.5795 8.51147 18.0323C8.45912 22.1183 10.4595 25.9577 13.8365 28.257C13.9434 28.3312 14.0917 28.3028 14.1659 28.1937C14.1965 28.1501 14.2117 28.0978 14.2074 28.0432C14.1594 27.3517 14.1506 26.658 14.1877 25.9643C14.1986 25.7417 14.1114 25.5258 13.9499 25.3731C11.8928 23.4512 10.7584 20.7396 10.8391 17.9254C10.994 12.7444 15.1258 8.56245 20.3046 8.3443ZM20.6319 7.36322e-05C10.7344 0.0262516 2.62361 8.05634 2.50145 17.956C2.4011 25.973 7.51889 32.8316 14.6677 35.3447C14.7942 35.3905 14.9338 35.3229 14.9796 35.1942C14.9927 35.1571 14.9971 35.1178 14.9905 35.0785C14.8967 34.4568 14.8073 33.8329 14.7266 33.2155C14.7004 32.9996 14.5608 32.812 14.3601 32.7247C8.52456 30.1767 4.77457 24.3958 4.82911 18.028C4.912 9.41759 11.9451 2.39536 20.5577 2.32773C29.36 2.25574 36.5481 9.39796 36.5481 18.185C36.5393 24.4961 32.7981 30.2029 27.0127 32.7269C26.8142 32.8141 26.6746 33.0018 26.6463 33.2177C26.5655 33.8395 26.4761 34.459 26.3823 35.0785C26.3627 35.2116 26.4521 35.336 26.5852 35.3556C26.6266 35.3621 26.6659 35.3578 26.703 35.3447C33.7819 32.8556 38.8714 26.1017 38.8714 18.1828C38.8735 8.13924 30.6864 -0.0282862 20.6319 7.36322e-05ZM16.4521 16.7038C16.4521 19.0402 18.3478 20.9359 20.6864 20.9359C23.0228 20.9359 24.9185 19.0402 24.9185 16.7038C24.9185 14.3652 23.0228 12.4695 20.6864 12.4695C18.3478 12.4695 16.4521 14.3652 16.4521 16.7038ZM24.4299 23.9944C23.6532 23.1763 22.2898 22.6506 20.682 22.6506C19.0721 22.6506 17.7087 23.1741 16.932 23.9944C16.535 24.3936 16.2929 24.9215 16.2471 25.4843C16.1162 26.6907 16.1882 27.7334 16.33 29.3957C16.4652 30.9817 16.7204 33.0956 17.0542 35.2487C17.292 36.7801 17.4862 37.6069 17.6629 38.2003C17.9464 39.1579 19.0132 40 20.6799 40C22.3465 40 23.4133 39.1601 23.6991 38.2003C23.8736 37.6091 24.0677 36.7823 24.3055 35.2487C24.6415 33.0956 24.8967 30.9839 25.0319 29.3957C25.1716 27.7334 25.2457 26.6929 25.1148 25.4843C25.0712 24.9215 24.8269 24.3936 24.4299 23.9944Z"
      fill="white"
    />
  </svg>
)

export const Amazon = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M40.5 20C40.5 31.0457 31.5457 40 20.5 40C9.4543 40 0.5 31.0457 0.5 20C0.5 8.9543 9.4543 0 20.5 0C31.5457 0 40.5 8.9543 40.5 20ZM24.3423 18.9755C24.1563 19.0995 23.8772 19.1925 23.5362 19.1925C23.0092 19.1925 22.5132 19.1305 22.0171 18.9755C21.9839 18.9672 21.9529 18.9589 21.9242 18.9512C21.8456 18.9301 21.7835 18.9135 21.7381 18.9135C21.6451 18.9135 21.6141 18.9755 21.6141 19.0995V19.4096C21.6141 19.5024 21.645 19.5643 21.6759 19.6262L21.6761 19.6266L21.6764 19.6269C21.7075 19.6579 21.7694 19.7197 21.8622 19.7506C22.3582 19.9676 22.9162 20.0606 23.5362 20.0606C24.1873 20.0606 24.6833 19.9056 25.0863 19.5956C25.4894 19.2855 25.6754 18.8825 25.6754 18.3555C25.6754 17.9834 25.5824 17.7044 25.3964 17.4564C25.2104 17.2394 24.9003 17.0224 24.4663 16.8674L23.5983 16.5263C23.2572 16.4023 23.0092 16.2783 22.9162 16.1543C22.7922 16.0303 22.7302 15.9063 22.7302 15.6893C22.7302 15.2242 23.0713 14.9762 23.7842 14.9762C24.1873 14.9762 24.5903 15.0382 24.9624 15.1622C25.0098 15.1741 25.0527 15.1859 25.0893 15.1961C25.1484 15.2124 25.1912 15.2242 25.2104 15.2242C25.3034 15.2242 25.3654 15.1622 25.3654 15.0382V14.7282C25.3654 14.6352 25.3344 14.5732 25.3034 14.5112C25.2724 14.4492 25.2104 14.4182 25.1174 14.3872C24.6523 14.2322 24.1873 14.1392 23.7223 14.1392C23.1332 14.1392 22.6372 14.2942 22.2652 14.5732C21.8931 14.8522 21.7072 15.2552 21.7072 15.7203C21.7072 16.4333 22.1102 16.9604 22.9162 17.2704L23.8463 17.6114C24.1563 17.7354 24.3423 17.8284 24.4663 17.9524C24.5903 18.0765 24.6214 18.2005 24.6214 18.3865C24.6214 18.6345 24.5284 18.8515 24.3423 18.9755ZM19.4751 18.6345V14.5112C19.4751 14.3872 19.5372 14.2942 19.7232 14.2942H20.3743C20.5293 14.2942 20.5912 14.3562 20.5912 14.5112V19.6266C20.5912 19.7816 20.5293 19.8436 20.3743 19.8436H19.9092C19.8162 19.8436 19.7542 19.8436 19.7232 19.8126C19.6612 19.7816 19.6301 19.7506 19.6301 19.6576L19.5682 19.2856C18.8861 19.7816 18.173 20.0296 17.46 20.0296C16.933 20.0296 16.53 19.8746 16.2509 19.5956C15.9719 19.3166 15.8479 18.8825 15.8479 18.3555V14.5112C15.8479 14.3562 15.9099 14.2942 16.0649 14.2942H16.7159C16.871 14.2942 16.933 14.3562 16.933 14.5112V18.0145C16.933 18.4175 16.995 18.6965 17.15 18.8825C17.305 19.0685 17.5531 19.1615 17.8941 19.1615C18.4211 19.1615 18.9481 18.9755 19.4751 18.6345ZM13.5849 19.8746H14.236C14.391 19.8746 14.453 19.8126 14.453 19.6576V15.7823C14.453 15.2552 14.329 14.8522 14.05 14.5732C13.771 14.2942 13.3989 14.1392 12.8719 14.1392C12.1588 14.1392 11.4148 14.3872 10.7017 14.9142C10.4537 14.3872 9.98868 14.1392 9.30662 14.1392C8.62458 14.1392 7.94252 14.3872 7.26047 14.8522L7.19847 14.5112C7.19847 14.4182 7.16746 14.3872 7.10546 14.3562C7.07445 14.3252 7.01245 14.3252 6.95045 14.3252H6.45441C6.2994 14.3252 6.23739 14.3872 6.23739 14.5422V19.6886C6.23739 19.8436 6.2994 19.9056 6.45441 19.9056H7.10546C7.26047 19.9056 7.32247 19.8436 7.32247 19.6886V15.5033C7.84952 15.1932 8.37656 15.0072 8.9346 15.0072C9.24462 15.0072 9.46164 15.1002 9.58565 15.2862C9.70965 15.4723 9.80266 15.7203 9.80266 16.0923V19.6576C9.80266 19.8126 9.86467 19.8746 10.0197 19.8746H10.6707C10.8257 19.8746 10.8877 19.8126 10.8877 19.6576V15.8443V15.6583V15.5033C11.4458 15.1622 11.9728 15.0072 12.4999 15.0072C12.8099 15.0072 13.0269 15.1002 13.1509 15.2862C13.2749 15.4723 13.3679 15.7203 13.3679 16.0923V19.6576C13.3679 19.8126 13.4299 19.8746 13.5849 19.8746ZM20.0645 26.1371C23.4127 26.1371 27.102 25.4241 30.4812 23.9979C31.0082 23.7809 31.4423 24.3389 30.9152 24.711C27.908 26.9432 23.5367 28.1212 19.7544 28.1212C14.484 28.1212 9.70967 26.1681 6.1134 22.9129C5.89638 22.6958 6.02039 22.4478 6.23741 22.4478C6.29941 22.4478 6.36142 22.4788 6.42342 22.5098C10.2987 24.773 15.1041 26.1371 20.0645 26.1371ZM30.3888 15.5343C30.6678 15.2242 31.1018 15.0692 31.7219 15.0692C32.0319 15.0692 32.3419 15.1002 32.621 15.1932C32.714 15.2242 32.7449 15.2242 32.8069 15.2242C32.8999 15.2242 32.962 15.1622 32.962 15.0072V14.6972C32.962 14.6042 32.931 14.5112 32.8999 14.4802C32.869 14.4492 32.8069 14.3872 32.7449 14.3562C32.3419 14.2632 31.9389 14.1702 31.5669 14.1702C30.6988 14.1702 30.0478 14.4182 29.5517 14.9452C29.0867 15.4413 28.8387 16.1853 28.8387 17.1154C28.8387 18.0454 29.0557 18.7585 29.5207 19.2545C29.9857 19.7506 30.6368 19.9986 31.5049 19.9986C31.9699 19.9986 32.4039 19.9366 32.7449 19.7816C32.838 19.7506 32.8999 19.7196 32.931 19.6576C32.962 19.6266 32.962 19.5336 32.962 19.4406V19.1305C32.962 18.9755 32.8999 18.9135 32.8069 18.9135C32.776 18.9135 32.714 18.9135 32.6519 18.9445C32.3109 19.0375 31.9699 19.0995 31.6599 19.0995C31.0709 19.0995 30.6368 18.9445 30.3578 18.6345C30.0787 18.3245 29.9548 17.8284 29.9548 17.1774V17.0224C29.9857 16.3403 30.1098 15.8443 30.3888 15.5343ZM33.4886 22.2928C33.8296 22.7268 33.3956 25.548 31.7835 26.9121C31.5045 27.0981 31.2875 27.0051 31.3805 26.7261C31.7525 25.8271 32.5586 23.7809 32.1865 23.2848C31.7835 22.7888 29.6133 23.0368 28.6523 23.1609C28.3733 23.1919 28.3112 22.9438 28.5902 22.7579C29.4894 22.1378 30.6674 21.9207 31.6595 21.9207C32.5896 21.9207 33.3336 22.1068 33.4886 22.2928ZM27.4736 14.2942H26.8226C26.6676 14.2942 26.6056 14.3562 26.6056 14.5112V19.6576C26.6056 19.8126 26.6676 19.8746 26.8226 19.8746H27.4736C27.6286 19.8746 27.6907 19.8126 27.6907 19.6576V14.5112C27.6907 14.3872 27.6286 14.2942 27.4736 14.2942ZM27.1331 12C27.3501 12 27.5362 12.062 27.6601 12.186C27.7842 12.279 27.8151 12.465 27.8151 12.651C27.8151 12.8371 27.7531 12.9921 27.6292 13.1161C27.5051 13.2401 27.3501 13.3021 27.1331 13.3021C26.9161 13.3021 26.7611 13.2401 26.6371 13.1161C26.5131 13.0231 26.451 12.8371 26.451 12.651C26.451 12.465 26.5131 12.31 26.6371 12.186C26.7611 12.062 26.9161 12 27.1331 12Z"
      fill="white"
    />
  </svg>
)

export const Chevron = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.4998 9.99995C12.3491 9.99995 12.1978 9.94928 12.0731 9.84528L8.49242 6.86128L4.91775 9.73795C4.63175 9.96928 4.21175 9.92395 3.98042 9.63661C3.74975 9.34995 3.79509 8.93061 4.08242 8.69928L8.08242 5.48061C8.32908 5.28128 8.68308 5.28395 8.92708 5.48795L12.9271 8.82128C13.2098 9.05661 13.2478 9.47728 13.0124 9.75995C12.8804 9.91795 12.6911 9.99995 12.4998 9.99995Z"
      fill="#002DC2"
    />
  </svg>
)

export const FilterIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 21V14M4 10V3M12 21V12M12 8V3M20 21V16M20 12V3M1 14H7M9 8H15M17 16H23"
      stroke="#1B1B1B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export const Polygon = () => (
  <svg
    width="48"
    height="42"
    viewBox="0 0 48 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="polygon"
  >
    <path
      d="M1.40467 22.7846C0.690141 21.547 0.690142 20.0222 1.40467 18.7846L11.0953 2C11.8098 0.762395 13.1303 0 14.5594 0H33.9406C35.3696 0 36.6901 0.762396 37.4047 2L47.0953 18.7846C47.8098 20.0222 47.8098 21.547 47.0953 22.7846L37.4047 39.5692C36.6901 40.8068 35.3696 41.5692 33.9406 41.5692H14.5594C13.1303 41.5692 11.8098 40.8068 11.0953 39.5692L1.40467 22.7846Z"
      fill="#5260FF"
    />
  </svg>
)

export const SocialLinkedIn = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM9.10938 8.82422V17H6.56641V8.82422H9.10938ZM9.30078 6.22656C9.30078 7.04688 8.64453 7.73047 7.82422 7.73047C7.03125 7.73047 6.375 7.04688 6.375 6.22656C6.375 5.43359 7.03125 4.77734 7.82422 4.77734C8.64453 4.77734 9.30078 5.43359 9.30078 6.22656ZM18.625 17H18.5977H16.082V13.0352C16.082 12.0781 16.0547 10.875 14.7422 10.875C13.4297 10.875 13.2383 11.8867 13.2383 12.9531V17H10.6953V8.82422H13.1289V9.94531H13.1562C13.5117 9.31641 14.332 8.63281 15.5625 8.63281C18.1328 8.63281 18.625 10.3281 18.625 12.5156V17Z"
      fill="#E4E7EC"
    />
  </svg>
)

export const SocialTwitter = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM29.2572 10L21.8468 18.6338L29.9059 30.39H23.9784L18.5511 22.4733L11.7561 30.39H10L17.7715 21.3362L10 10H15.9274L21.0667 17.4966L27.5012 10H29.2572ZM18.654 20.3072L19.4414 21.4361L24.8047 29.1252H27.5019L20.9297 19.7028L20.1422 18.5739L15.0862 11.325H12.3889L18.654 20.3072Z"
      fill="#E4E7EC"
    />
  </svg>
)

export const SocialYouTube = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23ZM17.3242 6.82812C17.9531 6.99219 18.4727 7.51172 18.6367 8.16797C18.9648 9.31641 18.9648 11.7773 18.9648 11.7773C18.9648 11.7773 18.9648 14.2109 18.6367 15.3867C18.4727 16.043 17.9531 16.5352 17.3242 16.6992C16.1484 17 11.5 17 11.5 17C11.5 17 6.82422 17 5.64844 16.6992C5.01953 16.5352 4.5 16.043 4.33594 15.3867C4.00781 14.2109 4.00781 11.7773 4.00781 11.7773C4.00781 11.7773 4.00781 9.31641 4.33594 8.16797C4.5 7.51172 5.01953 6.99219 5.64844 6.82812C6.82422 6.5 11.5 6.5 11.5 6.5C11.5 6.5 16.1484 6.5 17.3242 6.82812ZM13.8516 11.7773L9.96875 9.5625V13.9922L13.8516 11.7773Z"
      fill="#E4E7EC"
    />
  </svg>
)

export const SocialInstagram = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23ZM8.35547 11.75C8.35547 10.0273 9.75 8.60547 11.5 8.60547C13.2227 8.60547 14.6445 10.0273 14.6445 11.75C14.6445 13.5 13.2227 14.8945 11.5 14.8945C9.75 14.8945 8.35547 13.5 8.35547 11.75ZM9.44922 11.75C9.44922 12.8984 10.3789 13.8008 11.5 13.8008C12.6211 13.8008 13.5234 12.8984 13.5234 11.75C13.5234 10.6289 12.6211 9.72656 11.5 9.72656C10.3516 9.72656 9.44922 10.6289 9.44922 11.75ZM14.7539 7.75781C15.1641 7.75781 15.4922 8.08594 15.4922 8.49609C15.4922 8.90625 15.1641 9.23438 14.7539 9.23438C14.3438 9.23438 14.0156 8.90625 14.0156 8.49609C14.0156 8.08594 14.3438 7.75781 14.7539 7.75781ZM16.5859 6.66406C17.2969 7.375 17.5156 8.25 17.5703 9.23438C17.625 10.2461 17.625 13.2812 17.5703 14.293C17.5156 15.2773 17.2969 16.125 16.5859 16.8633C15.875 17.5742 15 17.793 14.0156 17.8477C13.0039 17.9023 9.96875 17.9023 8.95703 17.8477C7.97266 17.793 7.125 17.5742 6.38672 16.8633C5.67578 16.125 5.45703 15.2773 5.40234 14.293C5.34766 13.2812 5.34766 10.2461 5.40234 9.23438C5.45703 8.25 5.67578 7.375 6.38672 6.66406C7.125 5.95312 7.97266 5.73438 8.95703 5.67969C9.96875 5.625 13.0039 5.625 14.0156 5.67969C15 5.73438 15.875 5.95312 16.5859 6.66406ZM15.1094 16.5352C15.6289 16.3164 16.0664 15.9062 16.2578 15.3594C16.5366 14.6855 16.5193 13.2022 16.5078 12.218C16.5058 12.044 16.5039 11.8856 16.5039 11.75C16.5039 11.6194 16.5057 11.4656 16.5078 11.2958C16.5193 10.328 16.537 8.8385 16.2578 8.14062C16.0391 7.62109 15.6289 7.18359 15.1094 6.99219C14.4115 6.71304 12.922 6.73074 11.9542 6.74225C11.7844 6.74427 11.6306 6.74609 11.5 6.74609C11.3644 6.74609 11.206 6.74424 11.032 6.74221C10.0478 6.7307 8.56445 6.71336 7.89062 6.99219C7.34375 7.21094 6.93359 7.62109 6.71484 8.14062C6.4357 8.8385 6.4534 10.328 6.4649 11.2958C6.46692 11.4656 6.46875 11.6194 6.46875 11.75C6.46875 11.8856 6.4669 12.044 6.46486 12.218C6.45336 13.2022 6.43602 14.6855 6.71484 15.3594C6.93359 15.9062 7.34375 16.3164 7.89062 16.5352C8.56445 16.814 10.0478 16.7966 11.032 16.7851C11.206 16.7831 11.3644 16.7812 11.5 16.7812C11.6306 16.7812 11.7844 16.7831 11.9542 16.7851C12.922 16.7966 14.4115 16.8143 15.1094 16.5352Z"
      fill="#E4E7EC"
    />
  </svg>
)
